<template>
    <ion-grid style="height: calc(100% - 56px);" class="bg-transparent purple-purple-color overflow-auto p-0">
        <ion-row>
            <ion-col class="p-0">
                <slot/>
            </ion-col>
        </ion-row>

        <ion-row class="p-sticky light-light-background" style="bottom: 0; z-index: 1;">
            <ion-col>
                <button-base
                    :fill="BUTTON_FILL.OUTLINE"
                    class="coral-coral-color max-width"
                    @click="$emit('reset')"
                >
                    {{ $t('button.reset') }}
                </button-base>
            </ion-col>
            <ion-col class="d-flex ion-justify-content-end">
                <button-base
                    class="max-width"
                    @click="$emit('apply')"
                >
                    {{ $t('button.apply') }}
                </button-base>
            </ion-col>
        </ion-row>
    </ion-grid>
</template>

<script setup lang="ts">
import { IonCol, IonGrid, IonRow } from "@ionic/vue";

import ButtonBase from "@/components/button/ButtonBase.vue";

import { BUTTON_FILL } from "@/types/enum/ionicEnum";
import { FilterBaseEmits } from "@/types/emits";

defineEmits<FilterBaseEmits>()
</script>
